import React from 'react';
import '../../../Generals/Styles/FormContainerStyle.css';

export const GeneralFooterRegister = (props) => {
  const baseStyles = { textAlign: 'center', color: 'white', fontSize: '16px' };
  const styles = { ...baseStyles, ...props.style };
  const parameters = props.parameters;
  return (
    <div
      style={styles}
      // * parameter code: // * parameter code: INF_MSG_63
    >
      {parameters?.INF_MSG_63?.value?.split('-')[0] ||
        'Este sitio está protegido por reCAPTCHA y aplican la'}
      <a
        className="generalFooterLink"
        href="https://policies.google.com/privacy"
        target="_blank"
        rel="noreferrer">
        {parameters?.INF_MSG_63?.value?.split('-')[1] || 'Política de privacidad'}
      </a>{' '}
      {parameters?.INF_MSG_63?.value?.split('-')[2] || 'y los'}
      <a
        className="generalFooterLink"
        href="https://policies.google.com/terms"
        target="_blank"
        rel="noreferrer">
        {parameters?.INF_MSG_63?.value?.split('-')[3] || 'Términos de servicios de Google'}.
      </a>
    </div>
  );
};
